const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.datainsights.forwoodsafety.com',
    USER_TOKEN_URL: 'https://qhb0cq0ds9.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://xv3s1j8lp0.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.datainsights.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.datainsights.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.datainsights.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://dnjv875rxk.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
